let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dvuJ4")).then(() => parcelRequire('6P26b'));